export function useNumberParser() {
  function parse(value: string | number): number | null {
    if (typeof value === 'number') {
      return value
    }

    // trim whitespace
    let cleanedValue = value.trim()

    if (cleanedValue == '') {
      return null
    }

    // determine which character is the decimal separator and remove thousand separators
    const lastComma = cleanedValue.lastIndexOf(',')
    const lastDot = cleanedValue.lastIndexOf('.')

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        cleanedValue = cleanedValue.replace(/\./g, '')
      } else {
        cleanedValue = cleanedValue.replace(/,/g, '')
      }
    }

    // remove spaces (thousand separators)
    cleanedValue = cleanedValue.replace(/\s+/g, '')

    // standardize decimal separator
    cleanedValue = cleanedValue.replace(/,/g, '.')

    const parsed = Number(cleanedValue)
    return isNaN(parsed) ? null : parsed
  }

  return {
    parse,
  }
}
